'use client'
import { memo, type FC } from 'react'
import Image from 'next/image'
import styled from 'styled-components'
import type { TypeCmsModernImage, TypeCmsVideoExternal, TypeCmsVectorImage } from '@/schema'

type TypeVectorImage = TypeCmsVectorImage

type TypeFigure = {
  readonly media?: TypeCmsModernImage | TypeCmsVideoExternal | TypeVectorImage,
  readonly lazy?: boolean,
  readonly initialInView?: boolean,
  onClick?: () => void,
  readonly fill?: boolean,
  readonly outRef?: (node?: Element) => void,
	readonly onLoad?: () => void,
  readonly className?: string,
  readonly sizes?: string,
  readonly quality?: number
  readonly ariaHidden?: boolean
  readonly unoptimized?: boolean
}

const FigureStyled = styled.figure`
  display: block;
  position: relative;

  img {
    display: block;
    height: auto;
    object-fit: cover;
  }
`

function isTypeCmsVideo(media: TypeCmsModernImage | TypeCmsVideoExternal | TypeVectorImage): media is TypeCmsVideoExternal {
  return media?.type === 'video'
}

function isTypeVectorImage(media: TypeCmsModernImage | TypeCmsVideoExternal | TypeVectorImage): media is TypeVectorImage {
  return media?.type === 'svg'
}

export const getMediaVariantStr = (media) => {
  if(media?.l) return 'l'
  else if(media?.m) return 'm'
  else if(media?.s) return 's'
  else if(media?.sliderL) return 'sliderL'
  else if(media?.sliderM) return 'sliderM'
  else if(media?.sliderS) return 'sliderS'
  return null
}

export const Figure: FC<TypeFigure> = memo(({ media, lazy = true, fill = true, onClick = null, className = '', outRef = null, sizes = '70vw', quality = 75, ariaHidden = false, onLoad = null }) => {
  if (!media) return <figure className='placeholder' />
  if (isTypeCmsVideo(media)) return null

  return (
    <FigureStyled className={className} {...onClick && { onClick }}  {...outRef && { ref: outRef }} data-variant={getMediaVariantStr(media)} {...onLoad && { onLoad }}>
      {isTypeVectorImage(media) ?
        <Image src={media.src} alt={media.alt} fill={fill} aria-hidden={ariaHidden}
          {...!lazy && { priority: true }}
          {...!fill && { height: media.size.height }}
          {...!fill && { width: media.size.width }}
          unoptimized={true}
        />
        :
        <Image
          // placeholder='blur'
          src={media[getMediaVariantStr(media)]?.src} alt={media?.alt} fill={fill}
          {...!lazy && { priority: true }}
          {...!fill && { height: media[getMediaVariantStr(media)]?.size.height }}
          {...!fill && { width: media[getMediaVariantStr(media)]?.size.width }}
          sizes={sizes}
          {...quality !== 75 && { quality }}
          unoptimized={true}
          // {...unoptimized && { unoptimized: true }}
        />
      }
    </FigureStyled>
  )
})
